import {CircularProgress} from "@mui/material";

interface CustomTextSpinner {
    isLoading: boolean,
    text: string,
    textSpinner: string
}

export const TextSpinner = ({isLoading, text, textSpinner}: CustomTextSpinner) => {
    return (
        <>
            {isLoading ? (
                <>
                    {textSpinner}
                    <CircularProgress color="inherit" size={20} sx={{ marginLeft: 1 }} />
                </>
            ) : (
                <>{text}</>
            )}
        </>
    );
};